// extracted by mini-css-extract-plugin
export var assigneeBadge = "_m1-0";
export var assigneeDetails = "_m1-1";
export var assigneeInfo = "_m1-2";
export var dropdownContainer = "_m1-4";
export var dropdownImage = "_m1-5";
export var editAssigneeInfo = "_m1-3";
export var editAssigneeModalContainer = "_m1-6";
export var hidden = "_m1-8";
export var input = "_m1-7";